/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DataPointActionsAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of data point actions available
 */
define([], () => {
	class DataPointActionsAPI {

		/**
		 * @function DataPointActionsAPI#registerProvider
		 * @description Register a provider as a data point actions provider
		 * @param {name} name of the provider
		 * @param {provider} provider DataPointAction provider to register and contribute to data point actions
		 */
		registerProvider(/* provider */) {}

		/**
		 * @function DataPointActionsAPI#getDataPointActionList
		 * @description Returns a list of dataPointActions available for a specific item given a data point list.
		 * @param {array} selections list of data points selected
		 * @return {array} array containing all available actions
		 */
		getDataPointActionList(/* selections */) {}

	}

	return DataPointActionsAPI;
});